
document.addEventListener("DOMContentLoaded", function () {
  const titleWrappers = document.querySelectorAll(".title-wrapper");
  const tabButtons = document.querySelectorAll(".tab-button");
  const tabContents = document.querySelectorAll(".categories-data-content");

  // Helper: get attribute value
  function getTabValue(el) {
    return el.dataset.title || el.dataset.tab || el.dataset.category || null;
  }

  // Main function
  function setActiveTab(value) {
    if (!value) return;

    // Remove active classes
    titleWrappers.forEach(el => el.classList.remove("active"));
    tabButtons.forEach(el => el.classList.remove("active"));
    tabContents.forEach(el => el.classList.remove("active"));

    // Activate matching elements
    titleWrappers.forEach(el => {
      if (getTabValue(el) === value) el.classList.add("active");
    });
    tabButtons.forEach(el => {
      if (getTabValue(el) === value) el.classList.add("active");
    });
    tabContents.forEach(el => {
      if (getTabValue(el) === value) el.classList.add("active");
    });
  }

  // Initialize first active (either title or tab)
  const firstActive =
    document.querySelector(".title-wrapper.active") ||
    document.querySelector(".tab-button.active");
  if (firstActive) setActiveTab(getTabValue(firstActive));

  // On title click
  titleWrappers.forEach(title => {
    title.addEventListener("click", () => {
      setActiveTab(getTabValue(title));
    });
  });

  // On tab button click
  tabButtons.forEach(tab => {
    tab.addEventListener("click", () => {
      setActiveTab(getTabValue(tab));
    });
  });
});



document.querySelectorAll(".swiper.categories-data-slider").forEach((slider) => {
  new Swiper(slider, {
    loop: false,
    spaceBetween: 10,
    navigation: {
      nextEl: slider.querySelector(".swiper-button-next"),
      prevEl: slider.querySelector(".swiper-button-prev"),
    },
    pagination: {
      el: slider.querySelector(".swiper-pagination"),
      clickable: true,
    },
    breakpoints: {
      1450: {
        slidesPerView: 5,
      },
      1200: {
        slidesPerView: 4,
      },
      990: {
        slidesPerView: 3,
      },
      750: {
        slidesPerView: 3,
      },
      480: {
        slidesPerView: 2.5,
        spaceBetween: 30,
        centeredSlides: true,
      },
      300: {
        slidesPerView: 1.5,
        spaceBetween: 30,
        centeredSlides: true,
      },
    },
  });
});


